"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketsEmbed1Schema = void 0;
exports.BracketsEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/brackets-embed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "BracketsEmbed1",
    "description": "Used to embed brackets from the Bracket Editor",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "const": "rrn:content:ext:services:brackets-embed:1"
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string",
                    "pattern": "^[0-9]+"
                }
            },
            "required": [
                "id"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9icmFja2V0cy1lbWJlZC8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLEtBQUssRUFBRSxtRkFBbUY7SUFDMUYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLGFBQWEsRUFBRSxnREFBZ0Q7SUFDL0QsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixPQUFPLEVBQUUsMkNBQTJDO1NBQ3JEO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osSUFBSSxFQUFFO29CQUNKLE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsU0FBUztpQkFDckI7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixJQUFJO2FBQ0w7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==